// @flow

import React, { Component } from "react"
import styles from "./styles.css"

import Button from "react-toolbox/lib/button/Button"
import Spacer from "../Spacer"

export default class SaveButton extends Component {
  props: {
    onSave: () => any,
    onCancel: () => any,

    show: boolean,
  }

  render () {
    return (
      <div
        className={styles.root}
        style={{
          right: this.props.show ? "15px" : "-300px",
        }}
      >
        <Button icon="save" onClick={this.props.onSave} floating primary />
        <Spacer size={2}/>
        <Button icon="clear" onClick={this.props.onCancel} floating primary />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SaveButton/index.jsx